import React from "react";
import PropTypes from "prop-types";

import { Divider, Grid } from "..";

function ItemRow({
  text,
  subText,
  unitPrice,
  totalPrice,
  withDivider,
  children,
}) {
  return (
    <div data-test="summary-item-row">
      <Grid>
        <Grid.Row>
          <Grid.Column width={7}>
            <div data-test="summary-item-text" style={{ fontWeight: "bold" }}>
              {text}
            </div>
            {subText && (
              <div
                data-test="summary-item-subtext"
                style={{ color: "grey", fontStyle: "italic" }}
              >
                {subText}
              </div>
            )}
          </Grid.Column>
          <Grid.Column
            width={4}
            data-test="summary-item-unit-pricing"
            style={{ textAlign: "right" }}
          >
            {unitPrice}
          </Grid.Column>
          <Grid.Column
            width={5}
            data-test="summary-item-pricing"
            style={{ fontWeight: "bold", textAlign: "right" }}
          >
            {totalPrice}
          </Grid.Column>
        </Grid.Row>
      </Grid>
      {children && <div style={{ marginTop: "1em" }}>{children}</div>}
      {withDivider && <Divider data-test="summary-item-divider" />}
    </div>
  );
}

ItemRow.propTypes = {
  text: PropTypes.string,
  subText: PropTypes.string,
  unitPrice: PropTypes.node,
  totalPrice: PropTypes.node,
  withDivider: PropTypes.bool,
  children: PropTypes.node,
};

ItemRow.defaultProps = {
  text: "",
  subText: "",
  unitPrice: undefined,
  totalPrice: undefined,
  children: undefined,
  withDivider: true,
};

export default ItemRow;
